import avatar1 from "../../assets/avatar1.jpg";
import avatar2 from "../../assets/avatar2.jpg";
import avatar3 from "../../assets/avatar3.jpg";
import avatar4 from "../../assets/avatar4.jpg";

const data = [
  {
    avatar: avatar1,
    name: "Sameh Dheir",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque magnam ad alias aliquam qui dolor adipisci, eius, asperiores placeat sed ducimus exercitationem totam praesentium! Numquam, exercitationem labore? Tempore, voluptatibus itaque!",
  },
  {
    avatar: avatar2,
    name: "Hadi Dheir",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque magnam ad alias aliquam qui dolor adipisci, eius, asperiores placeat sed ducimus exercitationem totam praesentium! Numquam, exercitationem labore? Tempore, voluptatibus itaque!",
  },
  {
    avatar: avatar3,
    name: "Rashad Dheir",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque magnam ad alias aliquam qui dolor adipisci, eius, asperiores placeat sed ducimus exercitationem totam praesentium! Numquam, exercitationem labore? Tempore, voluptatibus itaque!",
  },
  {
    avatar: avatar4,
    name: "Ahmad Dheir",
    review:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque magnam ad alias aliquam qui dolor adipisci, eius, asperiores placeat sed ducimus exercitationem totam praesentium! Numquam, exercitationem labore? Tempore, voluptatibus itaque!",
  },
];

export default data;
